





import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: 'w-card'
})
export default class Card extends Vue {
  @Prop() public title?: string;
  @Prop(Boolean) public noPadding: Boolean;
}
